import React, { Component } from 'react';
import './Info.scss';

const appStoreUrl = 'https://apps.apple.com/fr/app/atlas-sport/id1506608683';
const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.atlas_app';

const features = [
  {
    icon: 'camera',
    title: 'Capture your workout',
    text: 'Take a photo of the board or write your session down. Your training is saved in seconds.',
  },
  {
    icon: 'chart',
    title: 'See your progress',
    text: 'Follow your loads, scores and personal records over time with a clear training history.',
  },
  {
    icon: 'search',
    title: 'Find every session',
    text: 'Search by movement, date or keyword and instantly bring back the workout you need.',
  },
];

function Icon({ name }) {
  const paths = {
    camera: <><path d="M4 8.5h3l1.4-2h7.2l1.4 2h3v9H4z"/><circle cx="12" cy="13" r="3.2"/></>,
    chart: <><path d="M4 19V5M4 19h16"/><path d="m7 15 3-4 3 2 5-7"/></>,
    search: <><circle cx="10.5" cy="10.5" r="5.5"/><path d="m15 15 5 5"/></>,
    check: <path d="m5 12 4 4L19 6"/>,
    home: <><path d="m3 11 9-7 9 7"/><path d="M5 10v10h14V10M9 20v-6h6v6"/></>,
    trophy: <><path d="M8 4h8v4c0 4-1.8 6-4 6s-4-2-4-6V4Z"/><path d="M8 6H4v2c0 2 1.5 3.5 4 3.5M16 6h4v2c0 2-1.5 3.5-4 3.5M12 14v4M8 20h8"/></>,
    note: <><rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8 8h8M8 12h8M8 16h5"/></>,
    profile: <><circle cx="12" cy="8" r="4"/><path d="M4 21c.7-4.2 3.3-6 8-6s7.3 1.8 8 6"/></>,
  };
  return <svg viewBox="0 0 24 24" aria-hidden="true">{paths[name]}</svg>;
}

function AppTabs({ active }) {
  const tabs = [
    { icon: 'home', label: 'Accueil' },
    { icon: 'trophy', label: 'Records' },
    { icon: 'chart', label: 'Progress' },
    { icon: 'note', label: 'Notes' },
    { icon: 'profile', label: 'Profil' },
  ];
  return (
    <div className="screen-tabs">
      {tabs.map(tab => (
        <span className={active === tab.label ? 'active-tab' : ''} key={tab.label}>
          <Icon name={tab.icon} />
          <small>{tab.label}</small>
        </span>
      ))}
    </div>
  );
}

export default class Info extends Component {
  render() {
    return (
      <main>
        <header className="site-header">
          <a className="brand" href="/" aria-label="Atlas Sport home">
            <img className="brand-logo" src="/images/atlas-sport-liquid.png" alt="" />
            <span>Atlas <strong>Sport</strong></span>
          </a>
          <nav aria-label="Main navigation">
            <a href="#features">Features</a>
            <a href="#how-it-works">How it works</a>
            <a className="nav-cta" href="#download">Get the app</a>
          </nav>
        </header>

        <section className="hero">
          <div className="hero-glow hero-glow-one" />
          <div className="hero-glow hero-glow-two" />
          <div className="page-width hero-grid">
            <div className="hero-copy">
              <span className="eyebrow"><span /> Built for everyday athletes</span>
              <h1>Your training.<br /><em>Your progress.</em><br />All in one place.</h1>
              <p className="hero-lead">Atlas Sport turns every workout into a clear, lasting training history. Save your sessions, track your records and see how far you have come.</p>
              <div className="hero-actions">
                <a className="button primary" href="#download">Download for free <span aria-hidden="true">↗</span></a>
                <a className="button secondary" href="#features">Discover Atlas</a>
              </div>
              <div className="hero-trust">
                <span><Icon name="check" /> Free to use</span>
                <span><Icon name="check" /> iOS &amp; Android</span>
              </div>
            </div>
            <div className="hero-visual">
              <div className="visual-orbit orbit-one" />
              <div className="visual-orbit orbit-two" />
              <div className="screen-stack" aria-label="Screens from the latest Atlas Sport app">
                <div className="app-screen app-screen-records" aria-hidden="true">
                  <div className="screen-status"><span>9:41</span><span>●●●</span></div>
                  <div className="records-head"><div><strong>Personal records</strong><span>6 movements tracked</span></div><b>＋</b></div>
                  <div className="record-search">⌕ <span>Search a movement</span></div>
                  <div className="record-filters"><b>Recent</b><span>A–Z</span><span>Weight</span><i>☆</i></div>
                  <div className="record-list">
                    <div><i>♜</i><span><strong>Bench Press</strong><small>Today · New PR</small></span><b>105<small>kg</small></b></div>
                    <div><i>♜</i><span><strong>Back Squat</strong><small>3 days ago</small></span><b>145<small>kg</small></b></div>
                    <div><i>♜</i><span><strong>Deadlift</strong><small>6 days ago</small></span><b>175<small>kg</small></b></div>
                    <div><i>♜</i><span><strong>Clean &amp; Jerk</strong><small>8 days ago</small></span><b>92.5<small>kg</small></b></div>
                  </div>
                  <AppTabs active="Records" />
                </div>
                <div className="app-screen app-screen-login">
                  <img src="/images/atlas-back-squat-record.png" alt="Atlas Sport Back Squat personal record showing a 145 kilogram best and its progress chart" />
                </div>
                <div className="app-screen app-screen-progress" aria-hidden="true">
                  <div className="screen-status"><span>9:41</span><span>●●●</span></div>
                  <div className="screen-title"><strong>Progress</strong><span>Last 6 weeks</span></div>
                  <div className="goal-card"><small>WEEKLY GOAL</small><strong>4 / 5</strong><div><i /></div><span>One session to reach your goal</span></div>
                  <h4>Training trend</h4>
                  <div className="bar-chart"><i /><i /><i /><i /><i /><i /></div>
                  <div className="chart-labels"><span>W1</span><span>W2</span><span>W3</span><span>W4</span><span>W5</span><span>W6</span></div>
                  <div className="insight-card"><small>ATLAS INSIGHT</small><strong>Your consistency is up 18%</strong><span>Keep the same rhythm this week.</span></div>
                  <AppTabs active="Progress" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="proof-strip" aria-label="Atlas Sport benefits">
          <div className="page-width proof-grid">
            <div><strong>One photo</strong><span>to save a workout</span></div>
            <div><strong>Every session</strong><span>easy to find</span></div>
            <div><strong>Your records</strong><span>visible over time</span></div>
          </div>
        </section>

        <section className="features-section" id="features">
          <div className="page-width">
            <div className="section-heading">
              <span className="section-kicker">Train. Save. Improve.</span>
              <h2>A training log that works<br />as hard as you do.</h2>
              <p>Less time typing, more time training. Atlas keeps the useful details without turning your workout into admin.</p>
            </div>
            <div className="feature-grid">
              {features.map(({ icon, title, text }, index) => (
                <article className="feature-card" key={title}>
                  <span className="feature-number">0{index + 1}</span>
                  <span className="feature-icon"><Icon name={icon} /></span>
                  <h3>{title}</h3>
                  <p>{text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="workflow-section" id="how-it-works">
          <div className="page-width workflow-grid">
            <div className="workflow-preview">
              <div className="workout-card">
                <div className="workout-top"><span>22 FEB 2021</span><span className="record-pill">Personal best</span></div>
                <h3>Back squat</h3>
                <div className="weight"><strong>100</strong><span>kg</span></div>
                <div className="progress-line"><span /><i /><b /></div>
                <div className="progress-labels"><span>78 kg</span><span>91 kg</span><span>100 kg</span></div>
              </div>
            </div>
            <div className="workflow-copy">
              <span className="section-kicker">Progress you can see</span>
              <h2>Every attempt builds your story.</h2>
              <p>Your best lifts do not happen overnight. Atlas keeps the full journey close, so each session has context and every win gets remembered.</p>
              <ul>
                <li><Icon name="check" /><span><strong>Track personal records</strong> for the movements that matter to you.</span></li>
                <li><Icon name="check" /><span><strong>Review your history</strong> before choosing your next target.</span></li>
                <li><Icon name="check" /><span><strong>Keep photos and notes</strong> attached to the right workout.</span></li>
              </ul>
            </div>
          </div>
        </section>

        <section className="download-section" id="download">
          <div className="page-width download-panel">
            <img className="download-logo" src="/images/atlas-sport-liquid.png" alt="Atlas Sport" />
            <span className="section-kicker">Attempts make success</span>
            <h2>Make today’s workout<br />part of your progress.</h2>
            <p>Download Atlas Sport for free on iPhone and Android.</p>
            <div className="store-buttons">
              <a href={appStoreUrl} target="_blank" rel="noreferrer"><img src="/images/appstore.png" alt="Download Atlas Sport on the App Store" /></a>
              <a href={playStoreUrl} target="_blank" rel="noreferrer"><img src="/images/playstore.png" alt="Get Atlas Sport on Google Play" /></a>
            </div>
          </div>
        </section>
      </main>
    )
  }
}
